import React from 'react';
import { Switch, Route } from 'react-router-dom';
import CombinedRoutes from './CombinedRoutes';
import UnauthenticatedLayout from '../pages/layout/UnauthenticatedLayout';
import AuthenticatedLayout from '../pages/layout/AuthenticatedLayout';
import Loadable from 'react-loadable';
import Loading from '../components/Loading/LoadingComponent';

const asyncNotFound = Loadable({
  loader: () => import('../pages/notfound/notfound.js'),
  loading: Loading
});

export default ({ childProps }) => (
  <Switch>
    {CombinedRoutes.map(
      (route, key) =>
        route.authenticated ? (
          <AuthenticatedLayout
            key={key}
            path={route.path}
            exact
            component={route.component}
            props={childProps}
          />
        ) : (
          <UnauthenticatedLayout
            key={key}
            path={route.path}
            exact
            component={route.component}
            props={childProps}
          />
        )
    )}

    <Route component={asyncNotFound} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/routes/Routes.js